module.exports = "/_next/static/media/57f888cee7ce4ebb58ecd486303692ee.svg";